module.exports = __webpack_public_path__ + "img/camera.2a7a644e.svg";